import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { CTAButton } from '../buttons/cta-button';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import mapValues from 'lodash/mapValues';
import assign from 'lodash/assign';
import reduce from 'lodash/reduce';
import forOwn from 'lodash/forOwn';
import isFunction from 'lodash/isFunction';
import { InputField } from '../inputs/input-field';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

export class FormBuilder extends Component {
  constructor (props) {
    super(props);

    this.state = {
      submitted: false
    };

    this.formRefs = {};
    this.getHeading = this.getHeading.bind(this);
    this.getSmallHeading = this.getSmallHeading.bind(this);
    this.getSubheading = this.getSubheading.bind(this);
    this.getDescription = this.getDescription.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.isScrolledIntoView = this.isScrolledIntoView.bind(this);
    this.scrollErrorIntoView = this.scrollErrorIntoView.bind(this);
    this.inputsValid = this.inputsValid.bind(this);
    this.toggleSubmitted = this.toggleSubmitted.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.shouldButtonBeDisabled = this.shouldButtonBeDisabled.bind(this);
    this.shouldButtonBeSpinning = this.shouldButtonBeSpinning.bind(this);
    this.renderInputElements = this.renderInputElements.bind(this);
    this.renderFormGroups = this.renderFormGroups.bind(this);
    this.isInputWrappedFunction = this.isInputWrappedFunction.bind(this);
  }

  getHeading () {
    if (this.props.heading) {
      return <h3 className="form-heading">{this.props.heading}</h3>;
    }

    return null;
  }

  getSmallHeading () {
    if (this.props.smallHeading) {
      return <h4 className="form-smallheading">{this.props.smallHeading}</h4>;
    }

    return null;
  }

  getSubheading () {
    if (this.props.subHeading) {
      return <h6 className="form-subheading">{this.props.subHeading}</h6>;
    }

    return null;
  }

  getDescription () {
    if (this.props.description) {
      return <p className="form-description">{this.props.description}</p>;
    }

    return null;
  }

  isInputWrappedFunction (value) {
    if (isFunction(get(value,'getWrappedInstance',''))) {
      return value.getWrappedInstance();
    }
    if (value && value.refs && value.refs.wrappedInstance) {
      return value.refs.wrappedInstance;
    }
    return value;
  }

  submitForm (e) {
    e.preventDefault();
    analyticsIntegrations.formSubmit(this.props.formname);
    const formIsValid = this.inputsValid();
    if (!formIsValid) {
      analyticsIntegrations.formFail(this.props.formname, 'Missing or incorrect form inputs');
      return;
    }
    const componentRefs = mapValues(this.refs,(value)=> this.isInputWrappedFunction(value));//keeping this.refs for backwards compatibility for services still using deprecated string refs
    const inputRefs = assign({}, componentRefs, this.formRefs, this.props.inputRefs);
    const getValues = reduce(inputRefs, (result, value) => {
      const newObj = result;
      if (newObj && 'function' === typeof(value.getValue)) {
        newObj[value.props.inputFieldName] = value.getValue();
        return newObj;
      }
      return;
    }, {});
    this.toggleSubmitted(true);
    this.props.submitAction(e.target.parentElement, (...args) => {
      setTimeout(() => {
        this.toggleSubmitted(false);
        this.props.submitCallback(...args);
      }, 0);
    }, inputRefs, getValues);
  }

  // Helper method to check if an element is in viewport
  isScrolledIntoView (el) {
    const $el = $(el);
    const $window = $(window);

    const documentViewTop = $window.scrollTop();
    const documentViewBottom = documentViewTop + $window.height();

    const elTop = $el.offset().top;
    const elBot = elTop + $el.height();

    return ((elBot <= documentViewBottom) && (elTop >= documentViewTop));
  }

  scrollErrorIntoView () {
    let firstError = false;
    const componentRefs = mapValues(this.refs,(value)=> this.isInputWrappedFunction(value));//keeping this.refs for backwards compatibility for services still using deprecated string refs
    const refs = { ...componentRefs, ...this.formRefs, ...this.props.inputRefs };

    forOwn(refs, (value)=>{
      if (!value.isValid()) {
        firstError = value;
        return false;
      }
    });

    if (firstError) {
      const node = ReactDOM.findDOMNode(firstError);

      // Only scroll to error if it is in viewport
      if (!this.isScrolledIntoView(node)) {
        $('html, body').animate({
          scrollTop: $(node).offset().top -= 100
        }, 1000);
      }
    }
  }

  inputsValid () {
    const { scrollToError } = this.props;
    let noErrors = true;

    if (scrollToError) {
      this.scrollErrorIntoView();
    }

    const componentRefs = mapValues(this.refs,(value)=> this.isInputWrappedFunction(value));//keeping this.refs for backwards compatibility for services still using deprecated string refs
    const inputRefs = assign({}, componentRefs, this.formRefs, this.props.inputRefs);
    forEach(inputRefs, (value) => {
      const isValid = value.isValid();
      if (!isValid) {
        noErrors = false;
      }
    });
    return noErrors;
  }

  toggleSubmitted (p) {
    const submitted = p;

    return this.setState({ submitted });
  }

  // will not work on custom elements unless they have
  // a clearValue function
  clearForm (e) {
    if (e) e.preventDefault();

    const { clearFilterFn } = this.props;
    const componentRefs = mapValues(this.refs,(value)=> this.isInputWrappedFunction(value)); //keeping this.refs for backwards compatibility for services still using deprecated string refs
    const inputRefs = assign({}, componentRefs, this.formRefs, this.props.inputRefs);
    // clear the form inputs & errors
    forEach(inputRefs, (ref) => {
      ref.clearValue();
    });
    if (clearFilterFn && isFunction(clearFilterFn)) clearFilterFn();
  }

  shouldButtonBeDisabled () {
    const { isButtonDisabled } = this.props;
    if (false === isButtonDisabled) {
      return isButtonDisabled;
    }
    return this.state.submitted || isButtonDisabled || false;
  }

  shouldButtonBeSpinning () {
    const { isButtonDisabled, isDisableSpinning } = this.props;
    if (isDisableSpinning) {
      return false;
    }
    if (false === isButtonDisabled) {
      return isButtonDisabled;
    }
    return this.state.submitted || isButtonDisabled || false;
  }

  renderInputElements (elements = this.props.formInputs) {
    const { ignoreTextAreaBlurValidation = false } = this.props;
    return elements.map((input, i) => {
      const { custom } = input;
      if (custom) {
        return (
          <div key={`custom-field-${i}`} className="form-inputs">
            { isFunction(custom) ? custom() : custom }
          </div>
        );
      }
      return (
        <InputField
          {...input}
          useBootstrapGrid={this.props.useBootstrapGrid}
          ignoreTextAreaBlurValidation={ignoreTextAreaBlurValidation}
          key={input.elementID || i }
          ref={(ref)=>{
            const actualRef = this.isInputWrappedFunction(ref);
            isFunction(input.ref) ? input.ref(actualRef)
              : this.formRefs[input.ref || `input ${i + 1}`] = actualRef;
          }} />
      );
    });
  }

  renderFormGroups () {
    const { formGroups } = this.props;

    if (formGroups) {
      return formGroups.map((group, i) => {
        // if group is an array, render as input fields
        const isInputArray = Array.isArray(group);

        return (
          <div className="clearfix" key={`group-${i}`}>
            { isInputArray ? this.renderInputElements(group)
              : group
            }
          </div>
        );
      });
    }

    return null;
  }

  render () {
    const { useBootstrapGrid } = this.props;
    return (
      <div className={`form-${this.props.formStyle}`}>
        <form id={this.props.id || this.props.formname} name={this.props.formname} className={this.props.formClassString}>
          <div className={classnames({ 'row': useBootstrapGrid })}>
            <div className={classnames({ 'col-xs-12': useBootstrapGrid })}>
              {this.getHeading()}
              {this.getSmallHeading()}
              {this.getSubheading()}
              {this.getDescription()}
            </div>
            { this.props.extended
              ? this.renderFormGroups()
              : this.renderInputElements()
            }
            {this.props.additionalBody}
            {!!this.props.errorText && (
              <div className={classnames({ 'col-xs-12': useBootstrapGrid })}>
                <div className="help-block text-danger text-left">
                  {this.props.errorText}
                </div>
              </div>
            )}
            <div className={classnames(this.props.containerClass, {
              'container-fluid': useBootstrapGrid
            })}>
              <div className={classnames(this.props.rowClass, {
                'row': useBootstrapGrid
              })}>
                { this.props.beforeCTA }
                <div className={classnames(this.props.btnColSize, {
                  'col-xs-12': useBootstrapGrid && !this.props.btnColSize
                })}>
                  <CTAButton
                    attributes={{...this.props.ctaButtonAttributes}}
                    onClickAction={this.submitForm}
                    buttonText={this.props.buttonText}
                    classNameString={this.props.buttonClass}
                    isDisabled={this.shouldButtonBeDisabled()}
                    spinning={this.shouldButtonBeSpinning()}
                    spinnerColor={this.props.spinnerColor ? this.props.spinnerColor : 'initial'}
                  />
                  {
                    this.props.clearFilterFn && isFunction(this.props.clearFilterFn) &&
                    <div className={classnames('text-center', {
                      'col-xs-12': useBootstrapGrid
                    })}>
                      <button className="btn btn-link remove-click-styling" onClick={this.clearForm}>
                        <FormattedMessage id="form_component.form_component.clear" defaultMessage="Clear" />
                      </button>
                    </div>
                  }
                </div>
                { this.props.afterCTA }
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

FormBuilder.defaultProps = {
  formClassString: 'form-horizontal',
  errorText: '',
  useBootstrapGrid: true
};

FormBuilder.propTypes = {
  formname: PropTypes.string.isRequired,
  containerClass: PropTypes.string,
  formStyle: PropTypes.oneOf(['modal', 'modal-plus', 'full', 'standard']),
  formInputs: PropTypes.array,
  formGroups: PropTypes.array,
  formClassString: PropTypes.string,
  heading: PropTypes.string,
  smallHeading: PropTypes.string,
  subHeading: PropTypes.string,
  description: PropTypes.string,
  additionalBody: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  errorText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.bool
  ]),
  submitAction: PropTypes.func,
  submitCallback: PropTypes.func,
  buttonText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  buttonClass: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  extended: PropTypes.bool,
  scrollToError: PropTypes.bool,
  btnColSize: PropTypes.string,
  isDisableSpinning: PropTypes.bool,
  customLabel: PropTypes.object,
  ctaButtonAttributes: PropTypes.object,
  inputRefs: PropTypes.array,
  rowClass: PropTypes.string,
  ignoreTextAreaBlurValidation: PropTypes.bool,
  useBootstrapGrid: PropTypes.bool
};
